import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Input } from "../ui/input";
import { api, apiError } from "../../lib/api";

export const ChangePassword = ({ className = "" }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ current_password: "", new_password: "", repeat: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.repeat) { setErr("Las contraseñas nuevas no coinciden"); return; }
    setBusy(true); setErr("");
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Contraseña actualizada");
      setOpen(false); setF({ current_password: "", new_password: "", repeat: "" });
    } catch (e2) { setErr(apiError(e2)); } finally { setBusy(false); }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} data-testid="change-password-open" className={`inline-flex items-center gap-2 rounded-full border border-black/10 bg-white px-4 py-2.5 text-sm font-semibold ${className}`}><KeyRound className="h-4 w-4" /> Cambiar contraseña</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="change-password-dialog" className="max-w-md rounded-3xl">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">Cambiar contraseña</DialogTitle>
            <DialogDescription>Mínimo 8 caracteres. La vas a usar desde el próximo ingreso.</DialogDescription>
          </DialogHeader>
          <form onSubmit={save} className="space-y-3">
            <Input data-testid="change-password-current" type="password" required placeholder="Contraseña actual" value={f.current_password} onChange={set("current_password")} className="h-12 rounded-xl" />
            <Input data-testid="change-password-new" type="password" required minLength={8} placeholder="Contraseña nueva" value={f.new_password} onChange={set("new_password")} className="h-12 rounded-xl" />
            <Input data-testid="change-password-repeat" type="password" required minLength={8} placeholder="Repetir contraseña nueva" value={f.repeat} onChange={set("repeat")} className="h-12 rounded-xl" />
            {err && <p data-testid="change-password-error" className="text-sm font-medium text-red-700">{err}</p>}
            <button data-testid="change-password-save" disabled={busy} className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-[var(--forest)] font-bold text-white">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Guardar</button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
